/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { DodDefinitionResponse } from "../models/dod-definition-response";
import { DodDefinitionIssue } from "../models/dod-definition-issue";
import { DodUsage } from "../models/dod-usage";
import { DodSaveResult } from "../models/dod-save-result";
import { DodEndPoint } from "../models/dod-end-point";
import { DodEndPointSubData } from "../models/dod-end-point-sub-data";
import { DodEndPointColumn } from "../models/dod-end-point-column";
import { DodEndPointDimension } from "../models/dod-end-point-dimension";
import { DodEndPointMeasure } from "../models/dod-end-point-measure";
import { DodEndPointAggregateType } from "../models/dod-end-point-aggregate-type";
import { DodSetMeasureAggregatesRequest } from "../models/dod-set-measure-aggregates-request";
import { DodSetEndPointFiltersRequest } from "../models/dod-set-end-point-filters-request";
import { DodSetRetiredRequest } from "../models/dod-set-retired-request";
import { DodReorderRequest } from "../models/dod-reorder-request";
import { DodMoveColumnsResponse } from "../models/dod-move-columns-response";
import { DodMoveColumnsRequest } from "../models/dod-move-columns-request";
import { DodColumnsBulkResponse } from "../models/dod-columns-bulk-response";
import { DodColumnsBulkRequest } from "../models/dod-columns-bulk-request";
import { DodRenameResponse } from "../models/dod-rename-response";
import { DodRenameRequest } from "../models/dod-rename-request";
@Injectable({
  providedIn: "root",
})
class AdminDodDefinitionService extends __BaseService {
  static readonly adminDodDefinitionGetDefinitionPath =
    "/api/AdminDodDefinition/Definition";
  static readonly adminDodDefinitionValidatePath =
    "/api/AdminDodDefinition/Validate";
  static readonly adminDodDefinitionGetUsagePath =
    "/api/AdminDodDefinition/Usage/{kind}/{id}";
  static readonly adminDodDefinitionSaveEndPointPath =
    "/api/AdminDodDefinition/SaveEndPoint";
  static readonly adminDodDefinitionSaveSubDataPath =
    "/api/AdminDodDefinition/SaveSubData";
  static readonly adminDodDefinitionSaveColumnPath =
    "/api/AdminDodDefinition/SaveColumn";
  static readonly adminDodDefinitionSaveDimensionPath =
    "/api/AdminDodDefinition/SaveDimension";
  static readonly adminDodDefinitionSaveMeasurePath =
    "/api/AdminDodDefinition/SaveMeasure";
  static readonly adminDodDefinitionSaveAggregateTypePath =
    "/api/AdminDodDefinition/SaveAggregateType";
  static readonly adminDodDefinitionSetMeasureAggregatesPath =
    "/api/AdminDodDefinition/SetMeasureAggregates";
  static readonly adminDodDefinitionSetEndPointFiltersPath =
    "/api/AdminDodDefinition/SetEndPointFilters";
  static readonly adminDodDefinitionSetRetiredPath =
    "/api/AdminDodDefinition/SetRetired";
  static readonly adminDodDefinitionDeletePath =
    "/api/AdminDodDefinition/Delete/{kind}/{id}";
  static readonly adminDodDefinitionReorderPath =
    "/api/AdminDodDefinition/Reorder";
  static readonly adminDodDefinitionMoveColumnsPath =
    "/api/AdminDodDefinition/MoveColumns";
  static readonly adminDodDefinitionSetColumnsBulkPath =
    "/api/AdminDodDefinition/SetColumnsBulk";
  static readonly adminDodDefinitionRenamePath =
    "/api/AdminDodDefinition/Rename";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  adminDodDefinitionGetDefinitionResponse(): __Observable<
    __StrictHttpResponse<DodDefinitionResponse>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdminDodDefinition/Definition`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodDefinitionResponse>;
      })
    );
  }
  adminDodDefinitionGetDefinition(): __Observable<DodDefinitionResponse> {
    return this.adminDodDefinitionGetDefinitionResponse().pipe(
      __map((_r) => _r.body as DodDefinitionResponse)
    );
  }
  adminDodDefinitionValidateResponse(): __Observable<
    __StrictHttpResponse<Array<DodDefinitionIssue>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdminDodDefinition/Validate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DodDefinitionIssue>>;
      })
    );
  }
  adminDodDefinitionValidate(): __Observable<Array<DodDefinitionIssue>> {
    return this.adminDodDefinitionValidateResponse().pipe(
      __map((_r) => _r.body as Array<DodDefinitionIssue>)
    );
  }

  /**
   * @param params The `AdminDodDefinitionService.AdminDodDefinitionGetUsageParams` containing the following parameters:
   *
   * - `kind`:
   *
   * - `id`:
   */
  adminDodDefinitionGetUsageResponse(
    params: AdminDodDefinitionService.AdminDodDefinitionGetUsageParams
  ): __Observable<__StrictHttpResponse<DodUsage>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/AdminDodDefinition/Usage/${params.kind}/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodUsage>;
      })
    );
  }
  /**
   * @param params The `AdminDodDefinitionService.AdminDodDefinitionGetUsageParams` containing the following parameters:
   *
   * - `kind`:
   *
   * - `id`:
   */
  adminDodDefinitionGetUsage(
    params: AdminDodDefinitionService.AdminDodDefinitionGetUsageParams
  ): __Observable<DodUsage> {
    return this.adminDodDefinitionGetUsageResponse(params).pipe(
      __map((_r) => _r.body as DodUsage)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionSaveEndPointResponse(
    request: DodEndPoint
  ): __Observable<__StrictHttpResponse<DodSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/SaveEndPoint`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionSaveEndPoint(
    request: DodEndPoint
  ): __Observable<DodSaveResult> {
    return this.adminDodDefinitionSaveEndPointResponse(request).pipe(
      __map((_r) => _r.body as DodSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionSaveSubDataResponse(
    request: DodEndPointSubData
  ): __Observable<__StrictHttpResponse<DodSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/SaveSubData`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionSaveSubData(
    request: DodEndPointSubData
  ): __Observable<DodSaveResult> {
    return this.adminDodDefinitionSaveSubDataResponse(request).pipe(
      __map((_r) => _r.body as DodSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionSaveColumnResponse(
    request: DodEndPointColumn
  ): __Observable<__StrictHttpResponse<DodSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/SaveColumn`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionSaveColumn(
    request: DodEndPointColumn
  ): __Observable<DodSaveResult> {
    return this.adminDodDefinitionSaveColumnResponse(request).pipe(
      __map((_r) => _r.body as DodSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionSaveDimensionResponse(
    request: DodEndPointDimension
  ): __Observable<__StrictHttpResponse<DodSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/SaveDimension`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionSaveDimension(
    request: DodEndPointDimension
  ): __Observable<DodSaveResult> {
    return this.adminDodDefinitionSaveDimensionResponse(request).pipe(
      __map((_r) => _r.body as DodSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionSaveMeasureResponse(
    request: DodEndPointMeasure
  ): __Observable<__StrictHttpResponse<DodSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/SaveMeasure`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionSaveMeasure(
    request: DodEndPointMeasure
  ): __Observable<DodSaveResult> {
    return this.adminDodDefinitionSaveMeasureResponse(request).pipe(
      __map((_r) => _r.body as DodSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionSaveAggregateTypeResponse(
    request: DodEndPointAggregateType
  ): __Observable<__StrictHttpResponse<DodSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/SaveAggregateType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionSaveAggregateType(
    request: DodEndPointAggregateType
  ): __Observable<DodSaveResult> {
    return this.adminDodDefinitionSaveAggregateTypeResponse(request).pipe(
      __map((_r) => _r.body as DodSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionSetMeasureAggregatesResponse(
    request: DodSetMeasureAggregatesRequest
  ): __Observable<__StrictHttpResponse<DodSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/SetMeasureAggregates`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionSetMeasureAggregates(
    request: DodSetMeasureAggregatesRequest
  ): __Observable<DodSaveResult> {
    return this.adminDodDefinitionSetMeasureAggregatesResponse(request).pipe(
      __map((_r) => _r.body as DodSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionSetEndPointFiltersResponse(
    request: DodSetEndPointFiltersRequest
  ): __Observable<__StrictHttpResponse<DodSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/SetEndPointFilters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionSetEndPointFilters(
    request: DodSetEndPointFiltersRequest
  ): __Observable<DodSaveResult> {
    return this.adminDodDefinitionSetEndPointFiltersResponse(request).pipe(
      __map((_r) => _r.body as DodSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionSetRetiredResponse(
    request: DodSetRetiredRequest
  ): __Observable<__StrictHttpResponse<DodSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/SetRetired`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionSetRetired(
    request: DodSetRetiredRequest
  ): __Observable<DodSaveResult> {
    return this.adminDodDefinitionSetRetiredResponse(request).pipe(
      __map((_r) => _r.body as DodSaveResult)
    );
  }

  /**
   * @param params The `AdminDodDefinitionService.AdminDodDefinitionDeleteParams` containing the following parameters:
   *
   * - `kind`:
   *
   * - `id`:
   */
  adminDodDefinitionDeleteResponse(
    params: AdminDodDefinitionService.AdminDodDefinitionDeleteParams
  ): __Observable<__StrictHttpResponse<DodSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/AdminDodDefinition/Delete/${params.kind}/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodSaveResult>;
      })
    );
  }
  /**
   * @param params The `AdminDodDefinitionService.AdminDodDefinitionDeleteParams` containing the following parameters:
   *
   * - `kind`:
   *
   * - `id`:
   */
  adminDodDefinitionDelete(
    params: AdminDodDefinitionService.AdminDodDefinitionDeleteParams
  ): __Observable<DodSaveResult> {
    return this.adminDodDefinitionDeleteResponse(params).pipe(
      __map((_r) => _r.body as DodSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionReorderResponse(
    request: DodReorderRequest
  ): __Observable<__StrictHttpResponse<DodSaveResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/Reorder`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodSaveResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionReorder(
    request: DodReorderRequest
  ): __Observable<DodSaveResult> {
    return this.adminDodDefinitionReorderResponse(request).pipe(
      __map((_r) => _r.body as DodSaveResult)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionMoveColumnsResponse(
    request: DodMoveColumnsRequest
  ): __Observable<__StrictHttpResponse<DodMoveColumnsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/MoveColumns`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodMoveColumnsResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionMoveColumns(
    request: DodMoveColumnsRequest
  ): __Observable<DodMoveColumnsResponse> {
    return this.adminDodDefinitionMoveColumnsResponse(request).pipe(
      __map((_r) => _r.body as DodMoveColumnsResponse)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionSetColumnsBulkResponse(
    request: DodColumnsBulkRequest
  ): __Observable<__StrictHttpResponse<DodColumnsBulkResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/SetColumnsBulk`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodColumnsBulkResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionSetColumnsBulk(
    request: DodColumnsBulkRequest
  ): __Observable<DodColumnsBulkResponse> {
    return this.adminDodDefinitionSetColumnsBulkResponse(request).pipe(
      __map((_r) => _r.body as DodColumnsBulkResponse)
    );
  }

  /**
   * @param request undefined
   */
  adminDodDefinitionRenameResponse(
    request: DodRenameRequest
  ): __Observable<__StrictHttpResponse<DodRenameResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodDefinition/Rename`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodRenameResponse>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodDefinitionRename(
    request: DodRenameRequest
  ): __Observable<DodRenameResponse> {
    return this.adminDodDefinitionRenameResponse(request).pipe(
      __map((_r) => _r.body as DodRenameResponse)
    );
  }
}

module AdminDodDefinitionService {
  /**
   * Parameters for AdminDodDefinitionGetUsage
   */
  export interface AdminDodDefinitionGetUsageParams {
    kind: 0 | 1 | 2 | 3 | 4 | 5;
    id: number;
  }

  /**
   * Parameters for AdminDodDefinitionDelete
   */
  export interface AdminDodDefinitionDeleteParams {
    kind: 0 | 1 | 2 | 3 | 4 | 5;
    id: number;
  }
}

export { AdminDodDefinitionService };
